import React from 'react';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from '@ers/hooks/';
import { Button, Icon } from '@ers/ui';
import { useHistory, useParams } from 'react-router';
import { archive } from '@ers/pages/home/Home.actions';

const Unarchive = () => {
    const history = useHistory();
    const { applicationId } = useParams();
    const { isPhone } = useMediaQuery();
    const dispatch = useDispatch();
    const handleClick = (e) => {
        applicationId && history.push(`/application/${applicationId}`);
        applicationId && dispatch(archive(applicationId, true));
    };
    return (
        <Button.Tertiary onClick={handleClick} className={isPhone && 'with-margin--bottom-1'}>
            <Icon name="circleplus" />
            Dodaj ponownie
        </Button.Tertiary>
    );
};
export default Unarchive;
